import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Press from './components/Press';
import Services from './components/Services';
import Machines from './components/Machines';
import OurProducts from './components/OurProducts';
import Cta from './components/Cta';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Products />
        <Press />
        <Machines />
        <OurProducts />
        <Services />
        <Cta />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
